<template>
  <div>
    <el-dialog
      class="registerDialogBox"
      :visible.sync="registerDialogVisible"
      :before-close="handleRegisterDialogClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <span slot="title">
        <div class="site_name">中国经济学年会投稿报名系统</div>
      </span>
      <el-form :model="registerForm" :rules="rules" ref="registerForm">
        <el-row class="loginDialogBoxTitle"
          ><i class="el-icon-user-solid">新用户注册（填写登录信息）</i></el-row
        >
        <el-form-item class="loginFormItem" prop="email">
          <el-input
            placeholder="注册邮箱可用来登录系统"
            v-model="registerForm.email"
          >
            <template slot="prepend"
              >邮<span style="margin-left: 2em" />箱<i class="el-icon-message"
            /></template>
          </el-input>
        </el-form-item>

        <div class="loginFormItem inlineFlex" prop="captcha_code">
          <el-input
            placeholder="输入认证码"
            v-model="registerForm.verify_code"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
            maxlength="4"
          >
            <template slot="prepend"
              >认<span style="margin-left: 0.5em" />证<span
                style="margin-left: 0.5em" />码<i class="el-icon-lock"
            /></template>
          </el-input>
          <el-button
            style="margin-left: 10px; padding: 12px"
            :disabled="sendMsgDisabled"
            @click="sendRegCapthaCode()"
          >
            <span v-if="!sendMsgDisabled">获取认证码</span>
            <span v-if="sendMsgDisabled">{{ codeTime + '秒后获取' }}</span>
          </el-button>
        </div>
      </el-form>
      <el-alert
        :style="{ display: registerMessageVisible }"
        :title="registerMessage"
        type="error"
        @close="registerMessageClose"
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%"
          @click="handleLogin"
          >登录</el-button
        >
      </span>
    </el-dialog>
    <div
      style="padding: 0 8px"
      class="bigFormDialog"
      v-if="$store.state.toGetCurrentUser.isLoginKey"
    >
      <RegistrationFormContent :eventId="eventId" ref="child" />
      <div class="formDialog__footer" style="position: initial">
        <!-- <el-button @click="cancelForm">取 消</el-button> -->
        <el-button type="primary" @click="handleSubmit" :loading="loading">{{
          loading ? '提交中 ...' : '提交报名表'
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getRegistration } from '@/apis/registration';
import { sendLoginCode, loginByCode } from '@/apis/register';
import RegistrationFormContent from '@/components/RegistrationFormContent.vue';

export default {
  components: { RegistrationFormContent },
  data() {
    return {
      registrated: false,
      registerDialogVisible: false,
      registerForm: {
        email: '',
        verify_code: '',
      },
      registerMessage: '',
      registerMessageVisible: 'none',
      sendMsgDisabled: false,
      loading: false,
      codeTime: 59,
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },
  computed: {
    eventId() {
      return Number(this.$route.query.eventId);
    },
  },
  mounted() {
    let forum_id = this.$route.query.eventId;
    this.forumId = Number(forum_id);
    getRegistration({ forum_id: forum_id }).then((res) => {
      if (res.status === 200 && res.data?.data?.registration_status === 1) {
        this.registrated = true;
      }
    });
    if (
      localStorage.eleToken !== null &&
      localStorage.eleToken !== '' &&
      localStorage.eleToken !== undefined
    ) {
      // this.showRegistrationForm = true;
    } else {
      // this.$store.commit('blOpenLoginBox', true);
      this.registerDialogVisible = true;
    }
  },
  methods: {
    // 注册认证码获取
    sendRegCapthaCode() {
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          sendLoginCode({
            email: this.registerForm.email,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  console.log(res.data.data);
                  this.registerMessage = '认证码已发至您的邮箱';
                  this.registerMessageVisible = 'block';
                  this.sendMsgDisabled = true;
                  let codeInterval = window.setInterval(() => {
                    this.codeTime--;
                    if (this.codeTime < 0) {
                      window.clearInterval(codeInterval);
                      this.codeTime = 59;
                      this.sendMsgDisabled = false;
                    }
                  }, 1000);
                } else {
                  this.registerMessage = res.data.message;
                  this.registerMessageVisible = 'block';
                }
              } else {
                this.$message.error('未能发送验证码');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    handleLogin() {
      loginByCode({
        user_name: this.registerForm.email,
        verify_code: this.registerForm.verify_code,
      }).then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            localStorage.eleToken = res.data.data.token;
            this.$store.dispatch('toGetCurrentUser').then(() => {
              this.$store.commit('AddIsLogin', 1);
              this.registerDialogVisible = false;
            });
          } else {
            // this.$message.error(res.data.message);
            this.loginMessage = res.data.message;
            this.loginMessageVisible = 'block';
          }
        } else {
          this.$message.error('未请求成功');
        }
      });
    },
    handleRegisterDialogClose() {},
    registerMessageClose() {},
    handleSubmit() {
      if (this.loading) {
        return;
      }
      this.$refs.child.handleSubmit();
    },
  },
};
</script>
